import http from 'hub-http/clients/apiClient';
import { registerQuery } from 'data-fetching-client';
export const getRecentFlowErrorsReport = flowId => http.get(`automationapps/v1/insights/canvas/errors/${flowId}`);
export const GET_FLOW_HEALTH_INSIGHTS = registerQuery({
  fieldName: 'flowHealthInsights',
  args: ['flowId'],
  fetcher: ({
    flowId
  }) => {
    return getRecentFlowErrorsReport(flowId);
  }
});